import type { PropsWithChildren } from "react";
import React from "react";
import { LazyIntlProvider } from "@ovrsea/i18n/src/LazyIntlProvider";

export const AtlasIntlProvider = ({ children }: PropsWithChildren<object>) => {
  return <LazyIntlProvider locale="en">{children}</LazyIntlProvider>;
};
